import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useColorModeValue,
  Divider,
} from '@chakra-ui/react';

export default function CustomModal({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  onSubmit, 
  isLoading, 
  submitText = 'ذخیره', 
  size = 'xl',
  isDirty = false
}) {
  // متغیرهای رنگی برای سازگاری بی‌نقص با حالت روشن و تاریک (Dark Mode)
  const bgContent = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue("gray.800", "white");
  const borderColor = useColorModeValue("gray.100", "whiteAlpha.200");
  const footerBg = useColorModeValue("gray.50", "whiteAlpha.50");
  const closeHoverBg = useColorModeValue('red.50', 'whiteAlpha.100');
  const bodyTextColor = useColorModeValue('gray.600', 'gray.300');
  const cancelTextColor = useColorModeValue('gray.600', 'gray.300');
  const cancelHoverBg = useColorModeValue('gray.200', 'whiteAlpha.200');

  // اگر مودال بسته است، هیچ چیز رندر نکن تا هیچ لایه‌ای روی صفحه نماند
  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={size}
      isCentered
      scrollBehavior="inside"
      motionPreset="slideInBottom"
      blockScrollOnMount={false}
      returnFocusOnClose={true}
      trapFocus={false}
      destroyOnClose={true}
    >
      <ModalOverlay 
        bg="blackAlpha.400" 
        backdropFilter="blur(6px)"
      />
      <ModalContent 
        bg={bgContent} 
        borderRadius="2xl"
        boxShadow="0 25px 50px -12px rgba(0, 0, 0, 0.25)"
        mx={{ base: 4, md: 0 }}
        maxH={{ base: "90vh", md: "85vh" }}
        display="flex"
        flexDirection="column"
        overflow="hidden"
      >
        <ModalHeader 
          fontSize="lg" 
          fontWeight="bold" 
          color={textColor}
          pt={6}
          pb={4}
          letterSpacing="tight"
          flexShrink={0}
        >
          {title}
        </ModalHeader>
        
        <ModalCloseButton 
          left={{ base: 3, md: 5 }} 
          right="auto" 
          top={5} 
          color="gray.400"
          _hover={{ bg: closeHoverBg, color: "red.500" }}
          borderRadius="lg"
          transition="all 0.2s"
        />

        <Divider borderColor={borderColor} flexShrink={0} />

        <ModalBody
          py={6}
          color={bodyTextColor}
          overflowY="auto"
          flex="1"
          minH={0}
          className="custom-scrollbar"
        >
          {children}
        </ModalBody>

        <Divider borderColor={borderColor} flexShrink={0} />

        <ModalFooter bg={footerBg} py={4} flexShrink={0}>
          <Button 
            variant="ghost" 
            mr={3} 
            onClick={onClose}
            borderRadius="xl"
            fontWeight="medium"
            color={cancelTextColor}
            _hover={{ bg: cancelHoverBg }}
          >
            انصراف
          </Button>
          
          {onSubmit && (
            <Button 
              bgGradient="linear(to-r, blue.500, cyan.400)"
              color="white"
              borderRadius="xl"
              fontWeight="bold"
              px={6}
              animation={isDirty ? "pulse 2s infinite" : "none"}
              sx={isDirty ? {
                '@keyframes pulse': {
                  '0%': { transform: 'scale(1)', boxShadow: '0 0 0 0 rgba(49, 151, 149, 0.7)' },
                  '70%': { transform: 'scale(1.05)', boxShadow: '0 0 0 10px rgba(49, 151, 149, 0)' },
                  '100%': { transform: 'scale(1)', boxShadow: '0 0 0 0 rgba(49, 151, 149, 0)' },
                }
              } : {}}
              _hover={{
                bgGradient: 'linear(to-r, blue.600, cyan.500)',
                transform: 'translateY(-1px)',
                boxShadow: '0 8px 15px -3px rgba(59, 130, 246, 0.4)',
              }}
              _active={{ transform: 'translateY(0)', boxShadow: 'none' }}
              transition="all 0.2s"
              onClick={onSubmit} 
              isLoading={isLoading}
              loadingText="در حال پردازش..."
            >
              {submitText}
            </Button>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}